module.exports = __webpack_public_path__ + "static/media/plant.889f96f7.png";